import React from "react";
import styled from "@emotion/styled";
import { toPercent } from "../../utils/toPercent";

const SummaryScoreItem = ({ group, topic, score, totalFinish }) => {
  return (
    <Container>
      <div>
        <QuizNoText>เล่มที่ {group}</QuizNoText>
        <QuizNameText>{topic}</QuizNameText>
      </div>
      <QuizScoreContainer>
        <span>
          {totalFinish > 0 ? score : "-"}&nbsp;&nbsp;คะแนน&nbsp;&nbsp;
        </span>
        <span>
          {totalFinish > 0 ? toPercent(score) : "-"}%
          {totalFinish > 0 && toPercent(score) >= 80 && (
            <>
              &nbsp;&nbsp;&nbsp;&nbsp;<strong>ดีมาก</strong>
            </>
          )}
        </span>
      </QuizScoreContainer>
    </Container>
  );
};

export default SummaryScoreItem;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  margin-bottom: 16px;
`;

const QuizNoText = styled.p`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #fc6b4b;
  margin-bottom: 0px;
`;

const QuizNameText = styled.p`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #058459;
  margin-bottom: 0px;
`;

const QuizScoreContainer = styled.div`
  display: flex column;
  border-bottom: 2px solid #e7eaee;

  font-family: "Noto Sans Thai";
  font-weight: 400;
  font-size: 16px;
  color: #4b5768;
`;
